module.exports = __webpack_public_path__ + "media/images/recruit/mv/img-mark-06-9d576fae1e688facc3c4dd3d5e9a5613.svg";